import { ElementDestination } from '../destination';
export class CustomRunDestination extends ElementDestination {
    get elementHandlerTable() {
        return {};
    }
}
